(function() {
    'use strict';

    angular
        .module('app.reportes')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/reportes-inscripciones',
                config: {
                    templateUrl: 'app/reportes/inscripciones.html',
                    controller: 'reportes.Inscripciones',
                    controllerAs: 'vm',
                    title: 'Inscripciones'
                }
            },
            {
                url: '/reportes-inscripciones-socios',
                config: {
                    templateUrl: 'app/reportes/inscripciones-socios.html',
                    controller: 'reportes.InscripcionesSocios',
                    controllerAs: 'vm',
                    title: 'Inscripciones'
                }
            },
            {
                url: '/reportes-tiempos',
                config: {
                    templateUrl: 'app/reportes/resultados-tiempos.html',
                    controller: 'reportes.ResultadosTiempos',
                    controllerAs: 'vm',
                    title: 'ResultadosTiempos'
                }
            },
            {
                url: '/reportes-premiacion',
                config: {
                    templateUrl: 'app/reportes/resultados-premiacion.html',
                    controller: 'reportes.ResultadosPremiacion',
                    controllerAs: 'vm',
                    title: 'ResultadosPremiacion'
                }
            }            
        ];
    }
})();
